import { ICalendarEvent } from "motw_core/Calendar/ICalendarEvent";
import moment = require("moment");
import { ECalendarName } from "motw_core/Calendar/ECalendarName";

export class CalendarEvent {
    constructor(readonly eventData: ICalendarEvent) {}

    get IsNew() {
        return this.BelongsToCalendar(ECalendarName.Free);
    }

    get HasFinished() {
        return moment().diff(this.eventData.end) > 0;
    }

    get IsToday() {
        const isToday = moment(this.eventData.start).isSame(moment(), "day");
        return isToday;
    }

    get IsCompleted() {
        return this.eventData.isCompleted;
    }

    get IsHappeningNow() {
        return (
            !this.IsAllDay &&
            this.IsInThePast(this.eventData.start) &&
            !this.IsInThePast(this.eventData.end)
        );
    }

    get HasNotStartedYet() {
        return !this.HasFinished && !this.IsHappeningNow;
    }

    get StartingInMinutes() {
        const thisMoment = moment();
        const eventStartMoment = moment(this.eventData.start);
        const result = eventStartMoment.diff(thisMoment, "minutes");
        return result;
    }

    get DurationInMinutes() {
        return moment(this.eventData.end).diff(this.eventData.start, "minutes");
    }

    get IsAllDay() {
        return this.DurationInMinutes >= 1440; // 24 hours
    }

    OccupiedHourNumbers() {
        const eventStartHour = moment(this.eventData.start).hour();
        let eventEndHour = moment(this.eventData.end).hour();
        const eventEndMoment = moment(this.eventData.end);

        // Round up to the nearest hour
        if (eventEndMoment.minutes() !== 0) {
            eventEndHour = eventEndMoment
                .add(1, "hours")
                .startOf("hour")
                .hour();
        }

        const occupiedHourNumbers = [...Array(24).keys()].slice(
            eventStartHour,
            eventEndHour
        );

        return occupiedHourNumbers;
    }

    DoesOccupyHour(hourNumber: number) {
        return this.OccupiedHourNumbers().includes(hourNumber);
    }

    BelongsToCalendar(calendarName: ECalendarName) {
        return this.eventData.calendar === ECalendarName[calendarName];
    }

    static FormatTime(dateTime: string) {
        const dateTimeMoment = moment(dateTime);
        const isOnTheHour = dateTimeMoment.minutes() === 0;

        const formattedTime = isOnTheHour
            ? dateTimeMoment.format(`ha`)
            : dateTimeMoment.format(`h:mma`);

        return formattedTime;
    }

    private IsInThePast(dateTime: string) {
        return moment().diff(dateTime) > 0;
    }
}
